import Swiper from "../../../../../vendor/swiper/swiper-bundle.mjs";

export default class EventSlider {
    constructor($el) {
        this.$el = $el;
        this.$swiper = this.$el.querySelector('[data-event-slider-swiper]');
        this.isTop10 = this.$el.dataset.eventSlider === 'top-10';
        this.$prev = this.$el.querySelector('[data-event-slider-prev]');
        this.$next = this.$el.querySelector('[data-event-slider-next]');

        this.initSlider = this.initSlider.bind(this);

        this.initSlider();
    }

    getTop10Spacing(offset) {
        return {
            spaceBetween: 16 + offset,
            slidesOffsetBefore: offset,
            slidesOffsetAfter: offset,
        };
    }

    getBreakpoints() {
        if ( ! this.isTop10) {
            return {
                480: {
                    slidesPerView: 3.2,
                },
                640: {
                    slidesPerView: 4.2,
                },
                768: {
                    slidesPerView: 5,
                },
                992: {
                    slidesPerView: 6,
                },
                1200: {
                    slidesPerView: 7,
                }
            };
        }

        const mediumTop10Spacing = this.getTop10Spacing(24);
        const largeTop10Spacing = this.getTop10Spacing(48);

        return {
            300: mediumTop10Spacing,
            992: largeTop10Spacing
        };
    }

    initSlider() {
        const spacing = this.isTop10 ? this.getTop10Spacing(24) : { spaceBetween: 16 };

        let config = {
            loop: false,
            slidesPerView: this.isTop10 ? 'auto' : 2.2,
            breakpoints: this.getBreakpoints()
        }

        if (this.$prev && this.$next) {
            config.navigation = {
                prevEl: this.$prev,
                nextEl: this.$next,
            };
        }

        new Swiper(this.$swiper, Object.assign({}, spacing, config));
    }
}
